import { Link } from "react-router-dom";
import { comicCategories } from "@/mocks/categories";

export default function CategoryQuickEntry() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-12 bg-background-50">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="text-lg md:text-xl font-label font-bold text-foreground-950">
            热门分类
          </h2>
          <p className="text-xs md:text-sm text-foreground-500 mt-1">
            按题材快速找到你想看的漫画
          </p>
        </div>
        <Link
          to="/search"
          className="text-xs md:text-sm font-label font-bold text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          全部作品 &gt;
        </Link>
      </div>

      <div className="grid grid-cols-4 md:grid-cols-8 gap-3 md:gap-4">
        {comicCategories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group flex flex-col items-center gap-2 py-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-colors"
          >
            <span className="w-11 h-11 flex items-center justify-center rounded-full bg-background-50 group-hover:bg-primary-500 transition-colors">
              <i
                className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}
              ></i>
            </span>
            <span className="text-xs md:text-sm font-label font-bold text-foreground-800 group-hover:text-primary-700">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}